"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EType = void 0;
/* eslint-disable */
//tslint:disable
let EType = exports.EType = /*#__PURE__*/function (EType) {
  /** подтверждение номера телефона **/
  EType["PhoneNumber"] = "phoneNumber";
  /** подтверждение при смене пароля **/
  EType["ChangePassword"] = "changePassword";
  /** подтверждение при смене email'а **/
  EType["ChangeEmail"] = "changeEmail";
  /** подтверждение при смене credit **/
  EType["ChangeCredit"] = "changeCredit";
  /** Подтверждение для бронирования объявления. **/
  EType["BookingAnnouncement"] = "bookingAnnouncement";
  /** Подтверждение для аутентификации. **/
  EType["AuthenticateCode"] = "authenticateCode";
  return EType;
}({});